export const GET_ALL_STATES_META = 'GET_ALL_STATES_META';
export const GET_ALL_STATES_META_FAILURE = 'GET_ALL_STATES_META_FAILURE';
export const GET_ALL_STATES_META_SUCCESS = 'GET_ALL_STATES_META_SUCCESS';
export const CLEAR_ALL_STATES_META_ERROR = 'CLEAR_ALL_STATES_META_ERROR';

export const SELECT_STATE = 'SELECT_STATE';

export const GET_DAILY_DATA = 'GET_DAILY_DATA';
export const GET_DAILY_DATA_SUCCESS = 'GET_DAILY_DATA_SUCCESS';
export const GET_DAILY_DATA_FAILURE = 'GET_DAILY_DATA_FAILURE';
export const CLEAR_DAILY_DATA_ERROR = 'CLEAR_DAILY_DATA_ERROR';

export const GET_CDC_RESOURCES = 'GET_CDC_RESOURCES';
export const GET_CDC_RESOURCES_SUCCESS = 'GET_CDC_RESOURCES_SUCCESS';
export const GET_CDC_RESOURCES_FAILURE = 'GET_CDC_RESOURCES_FAILURE';
export const CLEAR_CDC_RESOURCES_ERROR = 'CLEAR_CDC_RESOURCES_ERROR';

export const GET_CURRENT_STATE_DATA = 'GET_CURRENT_STATE_DATA';
export const GET_CURRENT_STATE_DATA_SUCCESS = 'GET_CURRENT_STATE_DATA_SUCCESS';
export const GET_CURRENT_STATE_DATA_FAILURE = 'GET_CURRENT_STATE_DATA_FAILURE';
export const CLEAR_CURRENT_STATE_DATA_ERROR = 'CLEAR_CURRENT_STATE_DATA_ERROR';

export const SET_GRAPH_DATA_TO_NEW_DEATHS = 'SET_GRAPH_DATA_TO_NEW_DEATHS';
export const SET_GRAPH_DATA_TO_NEW_CASES = 'SET_GRAPH_DATA_TO_NEW_CASES';
